import { createVanIconComponent } from "./van"

const Cluster = createVanIconComponent("cluster")
export default Cluster
